
      import { createLanguage, createTranslationFile } from '@vocab/webpack/web';
      
    const translations = createTranslationFile({
      "en": createLanguage(
        require.resolveWeak("./translations.json-en-virtual.json!=!../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJQbGVhc2UgY2hvb3NlIGEgZmlsZSI6IlBsZWFzZSBjaG9vc2UgYSBmaWxlLiJ9!"),
        () => import(
          /* webpackChunkName: "en-translations" */
          "./translations.json-en-virtual.json!=!../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJQbGVhc2UgY2hvb3NlIGEgZmlsZSI6IlBsZWFzZSBjaG9vc2UgYSBmaWxlLiJ9!"
        )
      ),
"th": createLanguage(
        require.resolveWeak("./translations.json-th-virtual.json!=!../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJQbGVhc2UgY2hvb3NlIGEgZmlsZSI6IuC4geC4o%2BC4uOC4k%2BC4suC5gOC4peC4t%2BC4reC4geC5hOC4n%2BC4peC5jCJ9!"),
        () => import(
          /* webpackChunkName: "th-translations" */
          "./translations.json-th-virtual.json!=!../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJQbGVhc2UgY2hvb3NlIGEgZmlsZSI6IuC4geC4o%2BC4uOC4k%2BC4suC5gOC4peC4t%2BC4reC4geC5hOC4n%2BC4peC5jCJ9!"
        )
      ),
"id": createLanguage(
        require.resolveWeak("./translations.json-id-virtual.json!=!../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJQbGVhc2UgY2hvb3NlIGEgZmlsZSI6IlNpbGFrYW4gcGlsaWggZmlsZS4ifQ%3D%3D!"),
        () => import(
          /* webpackChunkName: "id-translations" */
          "./translations.json-id-virtual.json!=!../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJQbGVhc2UgY2hvb3NlIGEgZmlsZSI6IlNpbGFrYW4gcGlsaWggZmlsZS4ifQ%3D%3D!"
        )
      ),
"en-AU": createLanguage(
        require.resolveWeak("./translations.json-en-AU-virtual.json!=!../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJQbGVhc2UgY2hvb3NlIGEgZmlsZSI6IlBsZWFzZSBjaG9vc2UgYSBmaWxlLiJ9!"),
        () => import(
          /* webpackChunkName: "en-AU-translations" */
          "./translations.json-en-AU-virtual.json!=!../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJQbGVhc2UgY2hvb3NlIGEgZmlsZSI6IlBsZWFzZSBjaG9vc2UgYSBmaWxlLiJ9!"
        )
      ),
"en-HK": createLanguage(
        require.resolveWeak("./translations.json-en-HK-virtual.json!=!../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJQbGVhc2UgY2hvb3NlIGEgZmlsZSI6IlBsZWFzZSBjaG9vc2UgYSBmaWxlLiJ9!"),
        () => import(
          /* webpackChunkName: "en-HK-translations" */
          "./translations.json-en-HK-virtual.json!=!../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJQbGVhc2UgY2hvb3NlIGEgZmlsZSI6IlBsZWFzZSBjaG9vc2UgYSBmaWxlLiJ9!"
        )
      ),
"en-ID": createLanguage(
        require.resolveWeak("./translations.json-en-ID-virtual.json!=!../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJQbGVhc2UgY2hvb3NlIGEgZmlsZSI6IlBsZWFzZSBjaG9vc2UgYSBmaWxlLiJ9!"),
        () => import(
          /* webpackChunkName: "en-ID-translations" */
          "./translations.json-en-ID-virtual.json!=!../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJQbGVhc2UgY2hvb3NlIGEgZmlsZSI6IlBsZWFzZSBjaG9vc2UgYSBmaWxlLiJ9!"
        )
      ),
"en-MY": createLanguage(
        require.resolveWeak("./translations.json-en-MY-virtual.json!=!../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJQbGVhc2UgY2hvb3NlIGEgZmlsZSI6IlBsZWFzZSBjaG9vc2UgYSBmaWxlLiJ9!"),
        () => import(
          /* webpackChunkName: "en-MY-translations" */
          "./translations.json-en-MY-virtual.json!=!../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJQbGVhc2UgY2hvb3NlIGEgZmlsZSI6IlBsZWFzZSBjaG9vc2UgYSBmaWxlLiJ9!"
        )
      ),
"en-NZ": createLanguage(
        require.resolveWeak("./translations.json-en-NZ-virtual.json!=!../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJQbGVhc2UgY2hvb3NlIGEgZmlsZSI6IlBsZWFzZSBjaG9vc2UgYSBmaWxlLiJ9!"),
        () => import(
          /* webpackChunkName: "en-NZ-translations" */
          "./translations.json-en-NZ-virtual.json!=!../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJQbGVhc2UgY2hvb3NlIGEgZmlsZSI6IlBsZWFzZSBjaG9vc2UgYSBmaWxlLiJ9!"
        )
      ),
"en-PH": createLanguage(
        require.resolveWeak("./translations.json-en-PH-virtual.json!=!../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJQbGVhc2UgY2hvb3NlIGEgZmlsZSI6IlBsZWFzZSBjaG9vc2UgYSBmaWxlLiJ9!"),
        () => import(
          /* webpackChunkName: "en-PH-translations" */
          "./translations.json-en-PH-virtual.json!=!../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJQbGVhc2UgY2hvb3NlIGEgZmlsZSI6IlBsZWFzZSBjaG9vc2UgYSBmaWxlLiJ9!"
        )
      ),
"en-SG": createLanguage(
        require.resolveWeak("./translations.json-en-SG-virtual.json!=!../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJQbGVhc2UgY2hvb3NlIGEgZmlsZSI6IlBsZWFzZSBjaG9vc2UgYSBmaWxlLiJ9!"),
        () => import(
          /* webpackChunkName: "en-SG-translations" */
          "./translations.json-en-SG-virtual.json!=!../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJQbGVhc2UgY2hvb3NlIGEgZmlsZSI6IlBsZWFzZSBjaG9vc2UgYSBmaWxlLiJ9!"
        )
      ),
"en-TH": createLanguage(
        require.resolveWeak("./translations.json-en-TH-virtual.json!=!../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJQbGVhc2UgY2hvb3NlIGEgZmlsZSI6IlBsZWFzZSBjaG9vc2UgYSBmaWxlLiJ9!"),
        () => import(
          /* webpackChunkName: "en-TH-translations" */
          "./translations.json-en-TH-virtual.json!=!../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJQbGVhc2UgY2hvb3NlIGEgZmlsZSI6IlBsZWFzZSBjaG9vc2UgYSBmaWxlLiJ9!"
        )
      ),
"th-TH": createLanguage(
        require.resolveWeak("./translations.json-th-TH-virtual.json!=!../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJQbGVhc2UgY2hvb3NlIGEgZmlsZSI6IuC4geC4o%2BC4uOC4k%2BC4suC5gOC4peC4t%2BC4reC4geC5hOC4n%2BC4peC5jCJ9!"),
        () => import(
          /* webpackChunkName: "th-TH-translations" */
          "./translations.json-th-TH-virtual.json!=!../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJQbGVhc2UgY2hvb3NlIGEgZmlsZSI6IuC4geC4o%2BC4uOC4k%2BC4suC5gOC4peC4t%2BC4reC4geC5hOC4n%2BC4peC5jCJ9!"
        )
      ),
"id-ID": createLanguage(
        require.resolveWeak("./translations.json-id-ID-virtual.json!=!../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJQbGVhc2UgY2hvb3NlIGEgZmlsZSI6IlNpbGFrYW4gcGlsaWggZmlsZS4ifQ%3D%3D!"),
        () => import(
          /* webpackChunkName: "id-ID-translations" */
          "./translations.json-id-ID-virtual.json!=!../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJQbGVhc2UgY2hvb3NlIGEgZmlsZSI6IlNpbGFrYW4gcGlsaWggZmlsZS4ifQ%3D%3D!"
        )
      ),
"en-PSEUDO": createLanguage(
        require.resolveWeak("./translations.json-en-PSEUDO-virtual.json!=!../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJQbGVhc2UgY2hvb3NlIGEgZmlsZSI6IlvGpMaa4bq94bq9xIPEg8Wh4bq94bq9IMOn4bipw7bDtsO2w7bFoeG6veG6vSDEg8SDIMaSw6zDrMaa4bq94bq9Ll0ifQ%3D%3D!"),
        () => import(
          /* webpackChunkName: "en-PSEUDO-translations" */
          "./translations.json-en-PSEUDO-virtual.json!=!../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJQbGVhc2UgY2hvb3NlIGEgZmlsZSI6IlvGpMaa4bq94bq9xIPEg8Wh4bq94bq9IMOn4bipw7bDtsO2w7bFoeG6veG6vSDEg8SDIMaSw6zDrMaa4bq94bq9Ll0ifQ%3D%3D!"
        )
      )
      });
  
      export { translations as default };
    